var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-textarea',_vm._b({class:_vm.classes,attrs:{"disabled":_vm.disabled,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-form-textarea',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }